import { createAsyncThunk } from "@reduxjs/toolkit";
import type { MailDomain } from "types";
import { apiGet } from "utilities/api";
import { SCOPES } from "utilities/constants/constants";

export const fetchMailDomains = createAsyncThunk(
	"mailDomains/fetch",
	apiGet<MailDomain[]>(
		(authConfig) => authConfig.MS_GRAPH_API_ENDPOINTS.GET_MAIL_DOMAINS(),
		[SCOPES.GRAPH_READ],
	),
);
